import React from "react";
import "../../Recommendations.scss";
import { Stars } from "..";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { interestedCareer } from "../../../../../../redux/actions";

const Card = ({ el, isCareer= false }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(interestedCareer());
    navigate(`/profile/recommendations/career/${el.id}`, {
      state: el,
    });
  };

  return (
    <div className="Recommendations-cont__item" key={el.id}>
      <div className="Recommendations-cont__item__topicCont">
        <p className="Recommendations-cont__item__topicCont__key">{isCareer ? 'Career':'Topic'}:</p>
        <p className="Recommendations-cont__item__topicCont__value">
          {el.unique_title}
        </p>
      </div>
      {/* <div className="Recommendations-cont__item__mentorCont">
      <p className="Recommendations-cont__item__mentorCont__key">
        Mentor:
      </p>
      <p className="Recommendations-cont__item__mentorCont__value">
        {el.first_name}
      </p>
    </div> */}
      <div className="Recommendations-cont__item__lane"></div>
      {
        <div className="Recommendations-cont__item__StarandRateCont">
          <Stars
            arr={[1, 2, 3, 4, 5]}
            // onChange={(newRating) => handleRatingChange(el.id, newRating)}
            // rating={mentorRates ? mentorRates[el.id] : ""}
            rate={el.score}
          />
          <p className="Recommendations-cont__item__StarandRateCont__rate">
            {+el?.score ? el.score : null}
          </p>
        </div>
      }
      <button className="Recommendations-cont__item__btn" onClick={handleClick}>
        <p className="Recommendations-cont__item__btn__text">View</p>
      </button>
    </div>
  );
};

export default Card;
